import { render, staticRenderFns } from "./ClaimList.vue?vue&type=template&id=15a8f116"
import script from "./ClaimList.vue?vue&type=script&lang=js"
export * from "./ClaimList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports